/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconNumber9Small = createReactComponent("number-9-small", "IconNumber9Small", [
  [
    "path",
    {
      d: "M10 15a1 1 0 0 0 1 1h2a1 1 0 0 0 1 -1v-6a1 1 0 0 0 -1 -1h-2a1 1 0 0 0 -1 1v2a1 1 0 0 0 1 1h3",
      key: "svg-0"
    }
  ]
]);

export { IconNumber9Small as default };
//# sourceMappingURL=IconNumber9Small.js.map
